import Grid2 from "@mui/material/Grid2";
import TitledGroup from "../ui/TitledGroup";
import EditableDataFieldsRenderer from "./EditableDataFieldsRenderer";

const TitledEditableFieldsRenderer = ({
  fields,
  quickFilter,
  title,
  icon,
  size,
  data,
  uppercase,
  fontWeight,
  onUpdateFn,
  bodySx,
}) => {
  if (size) {
    return (
      <Grid2 size={size}>
        <TitledGroup
          title={title}
          uppercase={uppercase}
          fontWeight={fontWeight}
          icon={icon}
          bodySx={bodySx}
        >
          <EditableDataFieldsRenderer
            quickFilter={quickFilter}
            fields={fields}
            data={data}
            onUpdateFn={onUpdateFn}
          />
        </TitledGroup>
      </Grid2>
    );
  }
  return (
    <TitledGroup
      title={title}
      uppercase={uppercase}
      fontWeight={fontWeight}
      icon={icon}
      bodySx={bodySx}
    >
      <EditableDataFieldsRenderer
        quickFilter={quickFilter}
        fields={fields}
        data={data}
        onUpdateFn={onUpdateFn}
      />
    </TitledGroup>
  );
};
export default TitledEditableFieldsRenderer;
